import objectPath from 'object-path'
import { debounceCallback } from 'utility/debounceCallback.util'
import {
  getTableGetCachedResult,
  loadByGET,
  loadByPOST,
} from '../../../action/Table'
import { isEmpty } from '../../../action/condition/State'
import { checkCrudCondition } from '../action/Crud'
import { createJsonTable } from '../action/JsonTable'

export const createTableRenderHelper = ({
  uischema,
  page,
  rowsPerPage,
  isWaitFetchApiTable,
  isWaitSearchOption,
  isUiChanged,
  jsonForm,
  receiveQueryParams,
  datasourceValue,
  designContext,
  setDatasourceValue,
  isLoadGET,
  isLoadApiGET,
  isLoadPOST,
  isLoadSEARCH,
  isLoadTABLE,
  isLoadJSON,
  isLoadSYNC,
  search,
  allParams,
  setIsRenderTable,
  setLoading,
  setRender,
  updateData,
  setTableData,
  refreshTableData,
  getPropTable,
  fetchSearch,
  jsonTable,
  propAction,
  syncTable,
  isRefreshTable,
  isResetAll,
  activeTab,
  setPage,
  pageData,
  setPageData,
  setIsUiChanged,
  tableDebounceName,
}) => {
  const renderTableData = (
    ui = uischema,
    isCallLoadApi = false,
    isRefreshTable = false,
    pageData = { page, rowsPerPage },
  ) => {
    if (isWaitFetchApiTable || isWaitSearchOption) {
      setLoading(false)
      return Promise.resolve()
    }

    let pageTable = objectPath.get(isUiChanged, ['pageTable', uischema.key])

    if (pageTable) {
      let { page, rowsPerPage } = pageTable
      pageData = {
        page: page + 1,
        rowsPerPage,
      }
    }

    let formData = objectPath.get(jsonForm, 'formData')
    if (Object.values(receiveQueryParams).length > 0) {
      objectPath.set(datasourceValue, 'queryParam', receiveQueryParams)
      objectPath.set(designContext, '@datasource', datasourceValue)
      setDatasourceValue(datasourceValue)
    }
    let prop = {
      ...getPropTable(),
      uischema: ui,
      isRefreshTable,
      pagination: {
        page: pageData.page || 1,
        rowsPerPage: pageData.rowsPerPage || ui?.rowsPerPage,
      },
      formData: formData,
      designContext,
      isSearchRequest: isLoadSEARCH,
    }
    if (ui?.loadData) {
      let { get, post, apiCondition } = ui.loadData
      let renderPromise = Promise.resolve()
      let cachedResult = null
      if (isLoadGET && get) {
        cachedResult = getTableGetCachedResult(get, prop, designContext)
      } else if (isLoadTABLE) {
        let loadTable = objectPath.get(ui, 'loadData.table')
        cachedResult = getTableGetCachedResult(
          { ...search, ...loadTable },
          prop,
          designContext,
        )
      }
      if (cachedResult) {
        setRender(true)
        if (cachedResult.promise) {
          setLoading(true)
          return cachedResult.promise.then((result) => {
            setLoading(false)
            return result?.tableData
          })
        }
        setLoading(false)
        return Promise.resolve(cachedResult.tableData)
      }
      setLoading(true)
      if (isLoadGET && get) {
        renderPromise = loadByGET(get, prop, designContext, setIsRenderTable)
      } else if (isLoadApiGET && apiCondition) {
        let filterApi = checkCrudCondition({
          action: ui.loadData,
          designContext,
          allParams,
        })
        if (filterApi?.length > 0) {
          renderPromise = Promise.all(
            filterApi.map((get) =>
              loadByGET(get, prop, designContext, setIsRenderTable),
            ),
          )
        } else {
          setLoading(false)
        }
      } else if (isLoadPOST && post) {
        renderPromise = loadByPOST(post, prop)
      } else if (isLoadSEARCH) {
        if (isRefreshTable) {
          renderPromise = loadByGET(
            search,
            prop,
            designContext,
            setIsRenderTable,
          )
        } else {
          debounceCallback(
            loadByGET,
            [search, prop, designContext, setIsRenderTable],
            tableDebounceName,
          )
        }
      } else if (isLoadTABLE) {
        let loadTable = objectPath.get(ui, 'loadData.table')
        if (isRefreshTable) {
          renderPromise = loadByGET(
            { ...search, ...loadTable },
            prop,
            designContext,
            setIsRenderTable,
          )
        } else {
          debounceCallback(
            loadByGET,
            [
              { ...search, ...loadTable },
              prop,
              designContext,
              setIsRenderTable,
            ],
            'load-by-get',
          )
        }
      } else if (isLoadJSON) {
        if (isCallLoadApi) {
          renderPromise = refreshTableData(uischema)
        }
        setLoading(false)
      } else if (isLoadSYNC) {
        setLoading(false)
      }
      setRender(true)
      return renderPromise
    } else {
      updateData([])
      setTableData([])
      setLoading(false)
      return Promise.resolve()
    }
  }

  const checkRenderTable = (isActiveTabChanged = false) => {
    if (fetchSearch === undefined || isWaitSearchOption) return

    if (isLoadJSON) {
      createJsonTable(jsonTable, propAction)
      setLoading(false)
    } else if (isLoadSYNC) {
      createJsonTable(syncTable, propAction)
    } else {
      let showAllResult = objectPath.get(search, 'showAllResult')

      let searchList = fetchSearch
        ? Object.values(fetchSearch).filter((value) => !isEmpty(value))
        : []
      let searchEmpty = searchList.length === 0
      let isPass = false
      if (searchEmpty && showAllResult) {
        isPass = true
      } else if (!searchEmpty) {
        isPass = true
      } else if (isLoadTABLE) {
        isPass = true
      } else if (isLoadGET) {
        isPass = true
      }

      let onChange = objectPath.get(isUiChanged, `onChange`)
      let lockPagination = objectPath.get(isUiChanged, `lockPagination`)
      let isRefresh = isRefreshTable || isActiveTabChanged
      if (isPass || activeTab) {
        if (lockPagination) {
          let pageData = { page: page + 1, rowsPerPage }
          renderTableData(uischema, false, isRefresh, pageData)
          objectPath.del(isUiChanged, 'lockPagination')
        } else {
          if (onChange) {
            let pageData = { page: 0, rowsPerPage }
            setPage(pageData.page)
            setPageData(pageData)
            renderTableData(uischema, false, isRefresh, pageData)
            objectPath.del(isUiChanged, `onChange`)
          } else {
            renderTableData(uischema, false, isRefresh, pageData)
          }
        }
      } else {
        setLoading(false)
      }
    }
    if (isResetAll) {
      objectPath.del(isUiChanged, 'isResetAll')
    }
    setIsUiChanged(isUiChanged)
  }

  return {
    renderTableData,
    checkRenderTable,
  }
}
